import { Stack, Typography, useMediaQuery } from "@mui/material";
import managementConstants from "../data/manager.json";
import { baseurl } from "../config";

type Props = {};

const OurSchoolManager = (props: Props) => {
  const isSmallScreen = useMediaQuery("(max-width:650px)");
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h4" sx={{ fontFamily: "inherit" }}>
        {managementConstants?.title}
        <br />
        <Typography variant="body2" sx={{ fontFamily: "inherit" }}>
          {managementConstants?.subtitle}
        </Typography>
      </Typography>

      <img
        src={`${baseurl}${managementConstants?.emblem}`}
        alt={`${managementConstants?.title}`}
        width="250px"
        style={{
          margin: isSmallScreen ? "1rem auto" : "1.5rem auto",
          borderRadius: "5px",
        }}
      />
      <Stack direction="column" spacing={2}>
        {managementConstants?.description?.map(
          (desc: string, index: number) => (
            <Typography
              sx={{ fontFamily: "inherit" }}
              variant="body2"
              textAlign="justify"
              key={index}
            >
              {desc}
            </Typography>
          )
        )}
      </Stack>
      <Typography
        variant="body2"
        textAlign="right"
        sx={{ fontWeight: "bold", fontFamily: "inherit" }}
      >
        {managementConstants?.by}
      </Typography>
    </Stack>
  );
};

export default OurSchoolManager;
